import React, { useContext, useEffect } from 'react';
import '../../../Styles/OpenOrders.scss'
import OpenOrders__Details__Small from './OpenOrders__Details__Small_2';
import '../../../Styles/OpenOrders__GridView.scss';

function OpenOrders__GridView(props) {

  return (
    <React.Fragment>
      <div className="grid-view__wrapper">
        {
          props.orderList.map(order =>
            <OpenOrders__Details__Small key={order.orderNumber} currency={props.currency} order={order} tableWidth={'40%'} optionGroups={props.optionGroups}></OpenOrders__Details__Small>
          )
        }
      </div>
    </React.Fragment>
  );
}

export default OpenOrders__GridView;
